import { useState } from 'react';
import { Box, ClickAwayListener, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

type ConfigurationInfoTitleProps = {
  title: string;
  info: string;
};

/** Configuration section title with hover, focus, and tap-accessible guidance. */
export function ConfigurationInfoTitle({ title, info }: ConfigurationInfoTitleProps) {
  const [open, setOpen] = useState(false);

  return (
    <Stack direction="row" alignItems="center" spacing={0.25} sx={{ minWidth: 0 }}>
      <Typography variant="subtitle2">{title}</Typography>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <Box component="span" sx={{ display: 'inline-flex' }}>
          <Tooltip
            title={info}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            disableTouchListener
            arrow
            slotProps={{ tooltip: { sx: { maxWidth: 320 } } }}
          >
            <IconButton
              size="small"
              type="button"
              aria-label={info}
              onClick={(event) => {
                event.stopPropagation();
                setOpen((current) => !current);
              }}
              sx={{ p: 0.25, color: 'text.secondary' }}
            >
              <InfoOutlined fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
      </ClickAwayListener>
    </Stack>
  );
}
